<template>
	<div>
		<v-container id="details">
			<div class="text-h4 font-weight-bold text-center pb-5" style="color: black">PACKING LIST</div>
			<v-row no-gutters>
				<v-col cols="6">
					<img :src="barcode" />
					<div class="text-h6 font-weight-bold" style="color: black"># {{ order.OrderID }}</div>
					<div class="help text-capitalize">
						{{
							new Date(order.created_at).toLocaleDateString('it-IT', {
								weekday: 'long',
								year: 'numeric',
								month: 'short',
								day: 'numeric',
							}) +
							' ' +
							new Date(order.created_at).toLocaleTimeString()
						}}
						- {{ order.Platform != 'store' ? order.Site : order.Platform }}
					</div>
					<div class="pt-5 pb-5">
						<v-avatar size="32px" tile>
							<img :src="getImageMarketplace(order.Platform)" :alt="order.Platform" />
						</v-avatar>
						<v-avatar size="16px" tile style="margin-left: 5px" v-if="order.ShippingAddress?.Country">
							<img :src="getImageFlag(order.ShippingAddress)" :alt="order?.ShippingAddress.Country" />
						</v-avatar>
					</div>
				</v-col>
				<v-col cols="6">
					<div class="text-right">
						<v-img v-if="getSettings.logo != ''" :src="getSettings.logo" />
						<strong>{{ getSettings.name }}</strong
						><br />
						{{ getSettings.InvoiceAddress?.Company }}<br />
						{{ getSettings.InvoiceAddress?.Address }}<br />
						{{ getSettings.InvoiceAddress?.City }}, {{ getSettings.InvoiceAddress?.Cap }} - {{ getSettings.InvoiceAddress?.Country }}<br />
						VAT: {{ getSettings.InvoiceAddress?.Vat }}<br />
						<template v-if="getSettings.InvoiceAddress?.Vat != getSettings.InvoiceAddress?.Fiscalcode">CF: {{ getSettings.InvoiceAddress?.Fiscalcode }} <br /></template>
						<span>{{ getSettings.ShippingAddress?.Phone }}</span>
					</div>
				</v-col>
			</v-row>

			<v-row no-gutters class="pt-5">
				<v-col cols="12" class="mb-5">
					<div class="help">Dati cliente</div>
					<template v-if="order.buyer?.name != '' || order.buyer?.lastname != ''">
						<div class="text-h5 font-weight-bold text-uppercase" style="color: black">{{ order.buyer?.name }} {{ order.buyer?.lastname }}</div>
					</template>
					<template v-else>
						<div class="text-h5 font-weight-bold" style="color: black">N.D.</div>
					</template>
					<div class="help">{{ order.buyer?.email }}</div>
				</v-col>
				<v-col cols="6">
					<div class="mt-2 font-weight-black">Dati Spedizione</div>
					<div class="">
						{{ order.ShippingAddress?.Name }} - {{ order.ShippingAddress?.Street1 }} - {{ order.ShippingAddress?.CityName }} {{ order.ShippingAddress?.PostalCode }} ({{
							order.ShippingAddress?.StateOrProvince
						}}) - {{ order.ShippingAddress?.Country }} - Tel: {{ order.ShippingAddress?.Phone }}
					</div>
				</v-col>
				<v-col cols="6">
					<div class="mt-2 font-weight-black">Dati di fatturazione</div>
					<div class="">
						{{ order.InvoiceAddress && order.InvoiceAddress?.Company ? 'Azienda: ' + order.InvoiceAddress?.Company + ' - ' : '' }}
						<template v-if="order.InvoiceAddress?.Address != ''">
							{{ order.InvoiceAddress?.Address }} - {{ order.InvoiceAddress?.City }} {{ order.InvoiceAddress?.Cap }} ({{ order.InvoiceAddress?.Province }}) - {{ order.InvoiceAddress?.Country }} <br />
						</template>
						<template v-if="order.InvoiceAddress?.Vat">
							Vat: {{ order.InvoiceAddress?.Vat }} - Fis. Code: {{ order.InvoiceAddress?.FiscalCode }} - SDI: {{ order.InvoiceAddress?.Sdi }} - Pec: {{ order.InvoiceAddress?.Pec }} <br />
						</template>
						Pagamento: {{ order.Checkout?.StatusPayment?.value }} {{ order.PaidTime ? '- Data Pagamento: ' + new Date(order.PaidTime).toLocaleString() : '' }}
					</div>
				</v-col>
			</v-row>

			<v-row no-gutters class="pt-5">
				<v-col cols="12">
					<v-divider></v-divider>
					<template>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Codice</th>
										<th class="text-left" width="70%">Prodotto</th>
										<th class="text-left">Qtà</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in order.Items" :key="item._id">
										<td>{{ item.SKU }}</td>
										<td>
											{{ item.Title }}
											<!-- combo: i prodotti scelti, da prelevare uno per uno -->
											<div v-for="choice in comboChoices(item)" :key="choice._variant" class="text-caption">
												{{ choice.qt * item.QuantityPurchased }} × {{ [choice.name, choice.variant].filter(Boolean).join(' - ') }}
												<template v-if="choice.sku">({{ choice.sku }})</template>
											</div>
										</td>
										<td>{{ item.QuantityPurchased }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</template>
					<v-divider></v-divider>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12">
					<p>Note: {{ order.Message }}</p>
					<template v-if="packing_list?.shipping_info?.courier != ''">
						<p>{{ packing_list?.shipping_info?.courier }}</p>
					</template>
					<template v-if="packing_list?.shipping_info?.tracking != ''">
						<p>Tracking Code: {{ packing_list?.shipping_info?.tracking }}</p>
					</template>
				</v-col>
			</v-row>
		</v-container>

		<div v-for="(page, index) in ldvPages" :key="'ldv-' + index" class="ldv-page">
			<img :src="page" :style="{ width: ldvPageSizes[index] ? ldvPageSizes[index].width + 'mm' : null }" alt="LDV" />
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import 'pdfjs-dist/legacy/build/pdf.worker.entry';

export default {
	name: 'PackingListPrint',
	data() {
		return {
			barcode: '',
			order: {},
			packing_list: {},
			ldvPages: [],
			ldvPageSizes: [],
			previousTitle: '',
		};
	},
	async created() {
		document.querySelector('#app > div.v-application--wrap > header').style.display = 'none';
		var fetchItem = await this.editItem(this.$route.params);
		this.packing_list = JSON.parse(JSON.stringify(fetchItem.result.packing_list));
		this.order = JSON.parse(JSON.stringify(fetchItem.result.order));
		// Il titolo della pagina è il nome proposto dal browser quando si salva la stampa in PDF.
		this.previousTitle = document.title;
		document.title = `PACKING LIST ${this.order.OrderID}`;
		this.barcode = await this.createBarcodeOrder(this.order);
		await this.loadLdv();
		await this.print();
	},
	beforeDestroy() {
		if (this.previousTitle) document.title = this.previousTitle;
	},

	computed: {
		...mapGetters({
			getSettings: 'settings/getSetting',
			getProfile: 'profile/getId',
		}),
	},
	methods: {
		// scelte del combo salvate sulla riga ordine (solo quelle con il componente risolto)
		comboChoices(item) {
			return Array.isArray(item.combo) ? item.combo.filter(choice => choice && choice._variant && choice.name) : [];
		},
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			editItem: 'packingLists/edit',
			getProfile: 'profile/getProfile',
			createBarcodeOrder: 'barcode/createBarcodeOrder',
			getShipmentLabel: 'packingLists/shipmentLabel',
		}),
		// Se l'ordine ha una spedizione con LDV, ne renderizza le pagine come immagini da accodare alla stampa.
		// Un errore qui non deve bloccare la stampa della packing list.
		async loadLdv() {
			try {
				const shipment = await this.getShipmentLabel(this.$route.params);
				if (!shipment || !shipment.label) return;

				const pdf = await pdfjsLib.getDocument({ data: atob(shipment.label) }).promise;
				const pages = [];
				const sizes = [];
				// 1pt = 1/72 pollice: converte le unità del PDF in mm per stampare l'etichetta
				// alla sua dimensione fisica reale, invece di farla riempire forzatamente la pagina
				// (alcuni corrieri, es. Poste via Spedisci Online, restituiscono un'etichetta piccola
				// su una pagina più grande: va mantenuta alla sua dimensione, non ingrandita).
				const PT_TO_MM = 25.4 / 72;
				// UPS invece restituisce l'etichetta originale già piccola di suo (non su una
				// pagina più grande): va ingrandita per coprire metà foglio A4 in stampa,
				// mantenendo le proporzioni originali.
				const courier = (this.packing_list?.shipping_info?.courier || '').toLowerCase();
				const A4_HALF_HEIGHT_MM = 148.5;
				for (let n = 1; n <= pdf.numPages; n++) {
					const page = await pdf.getPage(n);
					// Alcuni corrieri (es. FedEx con stock "PAPER_7X475") restituiscono l'etichetta
					// in landscape: ruotandola in verticale occupa correttamente la pagina di stampa
					// invece di apparire di traverso rispetto alla packing list (portrait).
					const baseViewport = page.getViewport({ scale: 1 });
					const isLandscape = baseViewport.width > baseViewport.height;
					const rotation = isLandscape ? (page.rotate + 90) % 360 : page.rotate;

					const printViewport = page.getViewport({ scale: 1, rotation });
					const widthMm = printViewport.width * PT_TO_MM;
					const heightMm = printViewport.height * PT_TO_MM;
					if (courier === 'ups') {
						sizes.push({
							width: (widthMm / heightMm) * A4_HALF_HEIGHT_MM,
							height: A4_HALF_HEIGHT_MM,
						});
					} else {
						sizes.push({ width: widthMm, height: heightMm });
					}

					const viewport = page.getViewport({ scale: 3, rotation });
					const canvas = document.createElement('canvas');
					canvas.width = viewport.width;
					canvas.height = viewport.height;
					await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
					pages.push(canvas.toDataURL('image/png'));
				}
				this.ldvPages = pages;
				this.ldvPageSizes = sizes;
				await this.$nextTick();
			} catch (e) {
				console.log('LDV non disponibile per la stampa', e.message);
			}
		},
		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img?.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},

		async print() {
			setTimeout(() => {
				window.print();
			}, 1500);
		},
	},
};
</script>

<style scoped>
.ldv-page {
	page-break-before: always;
	break-before: page;
	text-align: center;
}
.ldv-page img {
	/* width impostata inline in mm (dimensione fisica reale della pagina PDF del corriere):
	   qui solo un limite di sicurezza se dovesse superare l'area stampabile. */
	height: auto;
	max-width: 100%;
	max-height: 270mm;
}
</style>
